const constructors = { Date };

export default (ajv) => {
  ajv.addKeyword({
    keyword: 'instanceof',
    schemaType: 'string',
    error: { message: 'Must be an instance of Date' },
    compile(schema, parent) {
      const constructor = constructors[schema];
      return (data) => data instanceof constructor;
    }
  });

  ajv.addKeyword({
    keyword: 'nullableinstanceof',
    schemaType: 'string',
    error: { message: 'Must be an instance of Date or null' },
    compile(schema, parent) {
      const constructor = constructors[schema];
      return (data) => !data || (data instanceof constructor);
    }
  });
};
